import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MotifButton, MotifTextLink, MotifIcon } from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Current_User, Msl_Quarter_State_Info } from '@recoil/recoil';
import { actionIcLaunch24px } from '@ey-xd/motif-react/assets/icons';
import { subHeaderMSLPastQtrDetails, subHeaderMSLPastMonthDetails } from '@services/mslServices';
import {
  SubHeaderContainer,
  SubmitButtonContainer,
  Hyperlink,
  QuarterTitle,
  HyperlinkText,
  Divider,
} from '@atoms/subHeaderText/subHeader.styles';
import { BUTTON_TITLE } from '@constants/commonConstants';
import { structureMonth } from '@util/commonUtil';
import { logError } from '@util/commonFunctions';

const PastSubHeaderMsl = props => {
  const navigate = useNavigate();
  //Below Line direct-import-and-test-needed
  const [subHeaderData, setSubHeaderData] = useRecoilState(Msl_Quarter_State_Info); // eslint-disable-line
  const currentUser = useRecoilValue(Current_User);

  const MONTH = props.month;
  const YEAR = props.year;
  const forecast_type = props.forecast_type;
  const QUARTER = props.quarter;
  const fetchDateRange = async () => {
    try {
      const data = await (forecast_type === 'quarter'
        ? subHeaderMSLPastQtrDetails(QUARTER, YEAR, currentUser.email)
        : subHeaderMSLPastMonthDetails(QUARTER, MONTH, YEAR, currentUser.email));
      setSubHeaderData(data);
    } catch (error) {
      logError('fetchDateRange', error);
    }
  };

  useEffect(() => {
    fetchDateRange();
  }, [forecast_type, MONTH, YEAR, QUARTER, currentUser]);
  const fullMonth = MONTH ? structureMonth(MONTH) : '';
  const quarter = QUARTER.charAt(1);

  const renderQuarterInfo = () => {
    if (setSubHeaderData.length !== 0) {
      return (
        <QuarterTitle>
          {forecast_type === 'quarter'
            ? `Quarter ${quarter} FY ${YEAR}`
            : `${fullMonth} FY ${YEAR}`}
        </QuarterTitle>
      );
    }
  };

  const onHyperlinkClick = () => {
    if (
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') != 'null'
    ) {
      // Set flag to use userEmail for MSL hyperlink operations (CRM BI Dashboard) in super user mode
      // Allow navigation - don't prevent it with userEmail for Super User
      localStorage.setItem('isMslHyperlinkOperation', 'true');
    } else {
      // Regular user operation
      localStorage.setItem('isMslHyperlinkOperation', 'false');
    }
  };

  return (
    <SubHeaderContainer>
      {renderQuarterInfo()}
      <SubmitButtonContainer>
        <Hyperlink>
          <MotifTextLink
            variant="alt"
            href={`${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&pagetype=dashboard&id=${process.env.REACT_APP_EY_CRM_DASHBOARD_ID}&type=system`}
            target="_blank"
            onClick={e => {
              onHyperlinkClick(e);
            }}
          >
            <MotifIcon src={actionIcLaunch24px} />
            <HyperlinkText>Sales Forecasting Reporting Dashboard</HyperlinkText>
          </MotifTextLink>
        </Hyperlink>

        <Divider />
        <MotifButton
          variant="secondary"
          className="submitButton"
          onClick={() => {
            navigate('/');
          }}
        >
          {BUTTON_TITLE.CLOSE}
        </MotifButton>
      </SubmitButtonContainer>
    </SubHeaderContainer>
  );
};

export default PastSubHeaderMsl;
